export const badgeAllowedPlans = ["estate"];
export const badgeAllowedAddons = ["badge_monthly","badge_yearly"]; 